import * as actions from 'actions/HelpCentreActions/getContextActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
const { getContextActionsEnum } = actions;
const defaultState = {
    asyncStatus: INIT,
    contextFetched: false
};
export default function getContext(state = defaultState, action) {
    switch (action.type) {
        case getContextActionsEnum.GET_CONTEXT_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING
            });
        case getContextActionsEnum.GET_CONTEXT_SUCCESS:
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                contextFetched: true
            });
        case getContextActionsEnum.GET_CONTEXT_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR
            });
        case getContextActionsEnum.SET_NONORDER_REDIRECT:
            return Object.assign({}, state, {
                nonOrderRedirect: true
            });
        default:
            return state;
    }
}
